// pages/JourneyPage.tsx
import React from "react";
import {
  JourneyProvider,
} from "../components/Journey/JourneyProvider";
import { JourneyContainer } from "../components/Journey/JourneyContainer";

const JourneyPage: React.FC = () => (
  <JourneyProvider>
    <JourneyContainer />
  </JourneyProvider>
);

export default JourneyPage;
